import { UsfProductCardModeEnum } from '../../shared/constants/usf-product-card-mode.enum';
import { SearchModeConfig } from '../models/search-mode-config.model';

const getDefaultConfig = (): SearchModeConfig => ({
  // Search page
  displayHeader: true,
  displayBanners: true,
  displayBreadcrumbs: false,
  displayReplacementSection: false,
  displayExceptionFooter: false,
  displayFooter: true,
  displayFooterOptions: false,
  displayAddToListButton: true,
  displayFilledButton: false,
  footerText: 'i18n.search.chooseList', //does not apply to compare
  hideQuantity: false,
  selectableItem: false,
  // Original item
  originalItemHideQuantity: false,
  // Search result component
  displaySubstitutionHeader: false,
  displayReplacementHeader: false,
  // Search operations component
  displayAddToListOption: false, //TODO: rename for actual use
  disableAddToListOption: false,
  displayCancelAddToListOption: false,
  displayAddToInventory: false,
  enableCompareButton: false,
});

const getReplacementSearchConfig = (): SearchModeConfig => ({
  ...getDefaultConfig(),
  displayAddToListButton: true,
  displayReplacementSection: true,
  displayFooter: false,
  displayFooterOptions: true,
  displayFilledButton: true,
  selectableItem: false,
  disableAddToListOption: false,
});

const getAddToListSearchConfig = (): SearchModeConfig => ({
  ...getDefaultConfig(),
  displayFooter: false,
  displayFooterOptions: true,
  displayAddToListButton: true,
  displayFilledButton: false,
  footerText: 'i18n.search.addToList',
  selectableItem: false,
  displayAddToListOption: false,
  displayCancelAddToListOption: true,
  enableCompareButton: false,
  displayAddToInventory: false,
});

const getCompareProductsSearchConfig = (): SearchModeConfig => ({
  ...getDefaultConfig(),
  displayFooter: false,
  displayFooterOptions: true,
  displayAddToListButton: true,
  displayFilledButton: false,
  selectableItem: true,
  displayAddToListOption: false,
  displayCancelAddToListOption: false,
  enableCompareButton: true,
  displayAddToInventory: false,
  footerText: 'i18n.search.compare',
});

const getAddToInventorySearchConfig = (): SearchModeConfig => ({
  ...getDefaultConfig(),
  displayFooter: false,
  displayFooterOptions: true,
  displayAddToListButton: false,
  displayFilledButton: true,
  selectableItem: false,
  displayAddToListOption: false,
  displayCancelAddToListOption: false,
  enableCompareButton: false,
  displayAddToInventory: true,
  footerText: 'i18n.search.addToInventory',
});

const getCartReplacementSearchConfig = (): SearchModeConfig => ({
  ...getDefaultConfig(),
  displayHeader: false,
  displayBanners: false,
  displayBreadcrumbs: false,
  displayReplacementSection: true,
  displayExceptionFooter: true,
  displayFooter: false,
  displayFooterOptions: true,
  footerText: 'i18n.search.selectSubstitute',
  hideQuantity: true,
  originalItemHideQuantity: true,
  selectableItem: true,
  displaySubstitutionHeader: true,
  disableAddToListOption: false,
  displayAddToListButton: false,
});

const getExceptionSearchConfig = (): SearchModeConfig => ({
  ...getDefaultConfig(),
  displayHeader: false,
  displayBanners: false,
  displayBreadcrumbs: false,
  displayReplacementSection: true,
  displayExceptionFooter: true,
  displayFooter: false,
  displayFooterOptions: true,
  footerText: 'i18n.search.selectSubstitute',
  hideQuantity: true,
  originalItemHideQuantity: true,
  selectableItem: true,
  displaySubstitutionHeader: true,
  disableAddToListOption: true,
  displayAddToListButton: false,
});

const getSearchModeConfig = (
  mode: UsfProductCardModeEnum,
): SearchModeConfig => {
  switch (mode) {
    case UsfProductCardModeEnum.addToListSearch:
      return getAddToListSearchConfig();
    case UsfProductCardModeEnum.replacementSearch:
      return getReplacementSearchConfig();
    case UsfProductCardModeEnum.exceptionSearch:
      return getExceptionSearchConfig();
    case UsfProductCardModeEnum.cartReplacementSearch:
      return getCartReplacementSearchConfig();
    case UsfProductCardModeEnum.compareProducts:
      return getCompareProductsSearchConfig();
    case UsfProductCardModeEnum.addToInventorySearch:
      return getAddToInventorySearchConfig();
  }
  return getDefaultConfig();
};

export const SearchModeConfigUtil = {
  getDefaultConfig,
  getSearchModeConfig,
};
